import { generateClient } from "@/utils/helper/aws-generateClient-singleton";

const client = generateClient();

export async function fetchAllPaginatedGraphQl<T>(
  query: string,
  variables: Record<string, any>
): Promise<T[]> {
  let allItems: T[] = [];
  let nextToken: string | null | undefined = undefined;

  do {
    const response: any = await client.graphql({
      query,
      variables: {
        ...variables,
        nextToken,
      },
    });

    const queryName = Object.keys(response.data)[0];
    const items: T[] = response.data[queryName].items;
    nextToken = response.data[queryName].nextToken;

    allItems = [...allItems, ...items];
  } while (nextToken);

  return allItems;
}
